import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import {
    REPOSITORY_BASE_URL_TOKEN,
    RepositoryBaseUrlConfig,
    AppSettingsService as SharedAppSettingService,
} from 'shared';

import { AppSettings } from '../models/app-settings.model';

@Injectable({ providedIn: 'root' })
export class AppSettingsService extends SharedAppSettingService<AppSettings> {
    public constructor() {
        const http = inject(HttpClient);
        const baseUrlConfig = inject<Subject<RepositoryBaseUrlConfig>>(REPOSITORY_BASE_URL_TOKEN);

        super(http, baseUrlConfig);
    }
}
